/* Format days lang "es" */
export default (turns) => {
    let days = {
        '0' : 'Lunes',
        '1' : 'Martes',
        '2' : 'Miércoles',
        '3' : 'Jueves',
        '4' : 'Viernes',
        '5' : 'Sábado',
        '6' : 'Domingo'
    }
    let format = '';
    turns.forEach(turn=>{
        format += days[String(turn.day)]+'. ';
    });
    return format;
};


// WEBPACK FOOTER //
// ./src/filters/formatDays.js